import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { FetchBaseQueryArgs } from "@reduxjs/toolkit/dist/query/fetchBaseQuery";
import type { RootState } from "../redux/store";
import { SERVER_URL } from "../config/const";

const baseQueryWithAuth = (agrs: FetchBaseQueryArgs) =>
  fetchBaseQuery({
    ...agrs,
    prepareHeaders: (headers, { getState }) => {
      const { token } = (getState() as RootState).auth;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  });

const api = createApi({
  baseQuery: baseQueryWithAuth({ baseUrl: SERVER_URL }),
  reducerPath: "baseApi",
  endpoints: () => ({}),
  tagTypes: ["clients", "auth", "user", "request"],
});

export default api;
